import { GroupActionTypes, TaskGroupSummary } from '../types';

import interpolate from './interpolate';

/**
 * Display strings for the group card, row, and drawer. `display_name`/`description` may carry
 * `{placeholder}` tokens interpolated from the group context, rendered as-is (the backend decides
 * formatting). CTA label: an `expand` action's label (default "View tasks"), else "View".
 */
export default function getGroupDisplay(group: TaskGroupSummary): {
    title: string;
    description: string;
    ctaLabel: string;
} {
    const action = group.group_template.group_action;
    const ctaLabel = action.type === GroupActionTypes.EXPAND ? action.label ?? 'View tasks' : 'View';

    return {
        title: interpolate(group.group_template.display_name, group.context),
        description: interpolate(group.group_template.description, group.context),
        ctaLabel,
    };
}
